import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import PortfolioDetailCompositeSummary from './portfolio-detail-composite-summary';
import PortfolioDetailCompositeSelection from './portfolio-detail-composite-selection';
import PortfolioDetailPositions from './portfolio-detail-positions';
import { fetchPortfolios, selectStatus } from '../portfolios-slice';
import { useAuth0 } from '@auth0/auth0-react';
import { selectCompositeSelected } from './portfolio-detail-slice';
import { Link } from 'react-router-dom';
import { PageLoader } from '../../../app/page-loader';

/**
 * A detailed view of the portfolio.
 */
const PortfolioDetail: React.FC = () => {

  // Get the 'dispatch' method from the store
  const dispatch = useAppDispatch();
  const selectedComposite = useAppSelector(selectCompositeSelected);
  const status = useAppSelector(selectStatus);

  const { getAccessTokenSilently } = useAuth0();

  // React useEffect: applies after rendering
  useEffect(() => {
    if (status === 'idle') {
      const execute = async () => {
        const accessToken = await getAccessTokenSilently();
        dispatch(fetchPortfolios(accessToken));
      }
      execute();
    }
  });

  return (
    (status === 'pending') ?
      <PageLoader />
      :
      (selectedComposite && selectedComposite.portfolioComponents.length === 0) ?
        <div className='flex h-full w-full items-center justify-center'>
          <Link to='/portfolios/edit' className='[&>*]:cursor-pointer flex flex-col text-lg lg:text-2xl text-center text-white uppercase underline hover:opacity-80'>
            <label>Você ainda está sem Portfolio,</label>
            <label className='max-lg:hidden'>vamos criar um! (clique aqui)</label>
            <label className='lg:hidden'>vamos criar um! (toque aqui)</label>
          </Link>
        </div>
        : selectedComposite ?
          <div className='flex flex-col lg:flex-row-reverse h-full w-full overflow-y-auto text-neutral-300' >
            <div className='flex flex-col grow lg:h-full w-full lg:w-1/3 items-start lg:items-center justify-center'>
              <div className='flex lg:h-1/2 w-full items-center justify-center'>
                <PortfolioDetailCompositeSummary portfolioComposite={selectedComposite} />
              </div>
              <div className='flex h-36 lg:h-1/2 mt-5 lg:mt-0 w-full items-center justify-center'>
                <PortfolioDetailCompositeSelection portfolioComposite={selectedComposite} />
              </div>
            </div>
            <div className='flex relative h-full w-full lg:w-2/3 items-center justify-center lg:overflow-y-auto'>
              <PortfolioDetailPositions portfolioComposite={selectedComposite} />
            </div>
          </div >
          :
          <div>
            Sem portfolio
          </div>
  )
}

export default PortfolioDetail;